import { __assign } from "tslib";
/**
 * that can move index in column array
 */
export function moveIndexInTwoDimension(direction, options) {
    var currIndex = options.currIndex, columns = options.columns, total = options.total, infinite = options.infinite;
    // start index never small than 0
    // const index = Math.max(currIndex, 0);
    var lastIndex = total - 1;
    var isInOrder = infinite === 'order';
    var fillTotal = Math.ceil(total / columns) * columns;
    var resultIndex;
    switch (direction) {
        case 'ArrowUp': {
            var toIndex = (Math.max(currIndex, 0) - columns + fillTotal) % fillTotal;
            resultIndex = infinite ? toIndex : Math.min(toIndex, currIndex);
            break;
        }
        case 'ArrowRight': {
            if (isInOrder) {
                var tmp = currIndex + 1;
                resultIndex = tmp > lastIndex ? 0 : tmp;
                break;
            }
            var toIndex = Math.floor(currIndex / columns) * columns + ((currIndex + 1) % columns);
            resultIndex = infinite ? toIndex : Math.max(toIndex, currIndex);
            break;
        }
        case 'ArrowDown': {
            var toIndex = (currIndex + columns) % fillTotal;
            resultIndex = infinite ? toIndex : Math.max(toIndex, currIndex);
            break;
        }
        case 'ArrowLeft': {
            if (isInOrder) {
                var tmp = currIndex - 1;
                resultIndex = tmp < 0 ? lastIndex : tmp;
                break;
            }
            var toIndex = Math.floor(currIndex / columns) * columns +
                ((currIndex - 1 + columns) % columns);
            resultIndex = infinite ? toIndex : Math.min(toIndex, currIndex);
            break;
        }
        case 'Home':
            resultIndex = 0;
            break;
        case 'End':
            resultIndex = lastIndex;
            break;
        default:
            resultIndex = currIndex;
    }
    if (!infinite && resultIndex >= total) {
        return currIndex;
    }
    // * when that bigger then sourceTotal, mean that touch end line
    // * move to current full latest and move again.
    if (resultIndex >= total) {
        if (direction === 'ArrowRight') {
            resultIndex = fillTotal - 1;
        }
        return moveIndexInTwoDimension(direction, __assign(__assign({}, options), { currIndex: resultIndex }));
    }
    return resultIndex;
}
